import styles from './EmbeddedVideoPlayer.module.scss'

type EmbeddedVideoPlayerProps = {
  url: string
}

const withAutoplay = (url: string): string => {
  try {
    const parsed = new URL(url)
    if (!parsed.searchParams.has('autoplay')) {
      parsed.searchParams.set('autoplay', '1')
    }
    if (!parsed.searchParams.has('muted')) {
      parsed.searchParams.set('muted', '1')
    }
    return parsed.toString()
  } catch {
    return url
  }
}

export const EmbeddedVideoPlayer = ({ url }: EmbeddedVideoPlayerProps) => (
  <div id="VideoPlayer" className={styles.EmbeddedWrapper}>
    <iframe
      src={withAutoplay(url)}
      title="Embedded livestream"
      allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
  </div>
)
